export { YO_MONOSYNTH_CONFIG } from "./yo-mono";
export { YO_FM_SYNTH_CONFIG } from "./yo-fm";
export type { VirtualSynthConfig } from "./types";

import { YO_MONOSYNTH_CONFIG } from "./yo-mono";
import { YO_FM_SYNTH_CONFIG } from "./yo-fm";

/**
 * All available virtual synths
 * Add new virtual synths to this array to make them available in the app
 */
export const VIRTUAL_SYNTHS = [
  YO_MONOSYNTH_CONFIG,
  YO_FM_SYNTH_CONFIG,
] as const;
